export const scrollToTop = () => {
  setTimeout(() => {
    (window.top ?? window).scrollTo(0, 0);
    const elementMain = document.getElementById("main");
    const elementHeader = document.getElementById("header");
    const elementHeaderBanner = document.getElementById("header-banner");
    if (elementMain && elementHeader) {
      elementHeader.classList.remove("compact");
      if (!elementHeaderBanner) {
        elementMain.classList.add("p-top-main");
      } else {
        elementMain.classList.add("p-top-main-w-banner");
      }
      // based on this clientHeight apply CSS styles, don't use inline styles to avoid jitter
      // elementMain.style.paddingTop = `${elementHeader.clientHeight}px`;
    }
  });
};
